<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img @click="fanhui()" src="../../assets/images/licai/fanhui.png"/>
			<p class="">关于我们</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4> 关于我们</h4>
				<p>

美国富达投资集团（Fidelity Investment Group）

官网：www.fidelity.com

成立时间：1946年

公司总部：美国波士顿

香港地址：香港干诺道中41号新克斯大厦17及19楼

富达管理研究(香港)有限公司（trading as Fidelity Investments, Fidelity Institutional Asset Management）

集团介绍

美国富达投资集团（Fidelity Investment Group）目前全球最大的专业基金公司。富达投资集团的分支机构遍布全球15个国家和地区。目前为全球1200多万位投资者管理的资产高达1万亿美元，占美国共同基金总额的1/8，倍受投资者和基金市场的关注。

富达投资集团注重"自下而上"的选股策略，善于发掘股价被低估或者股价落后于市场涨幅、具有长期投资潜力的公司的股票，因此其基金经理的作用非常重要，而且富达集团也拥有许多世界知名的基金经理，彼得·林奇(Peter Lynch)就是其中最为出名的一个，他管理麦哲伦基金的十三年里，年平均收益率为29%，而同期标准普尔500指数的涨幅平均只为14%。此后富达集团也出现了许多杰出的基金管理经理，1998年，它有4名基金经理人的表现列于最佳基金经理的前20名。与基金投资人保持一致，开发新的投资策略并支持现有策略，并代表我们自身达成战略交易。

成立背景

富达成立于1969年，是1946年在美国波士顿创立的Fidelity Investments旗下的国际公司。在1980年，富达脱离美国母公司独立经营。现时，富达的股权主要由管理层和创始家族成员持有。

业务范围

富达在全球管理的资产达2,900亿美元，客户遍布亚太区、欧洲、中东和南美洲25个国家。服务的客户包括中央银行、主权财富基金、大型机构、金融企业、保险公司、财富管理公司及个人投资者。

资产管理

我们向个人和机构投资者提供全球研究和投资服务。但这只是故事的一部分。加入我们的世界领先的资产管理业务之一。

个人投资

退休计划。投资组合指导。经纪服务。拥有超过3,500万个人投资者依赖于我们，我们的个人投资团队正在与客户建立终身关系，并提供成本效益高的解决方案。

工作场所投资

我们与雇主合作--包括“财富”100强中的许多雇主--为他们的雇员制定战略性的、富有吸引力的福利计划。我们的团队还提供一系列重要的服务，从记录保存和投资，到服务在明确的贡献，确定的利益，健康和福利和库存计划服务。

诚信制度

我们帮助金融中介公司驾驭当今不断变化的金融格局--提供变革性的技术、专门的支持和创新的解决方案。我们的产品涵盖了一系列的清算、托管、投资产品、经纪和交易服务-提高运营效率，提高信心、透明度和业绩。加入我们的忠诚制度，并确保我们的客户繁荣。

德文郡投资者

40多年来，德文郡一直是通过其基金进行风险投资的领先者--在世界上一些规模最大、最具创新性的公司中占据了一席之地。作为富达投资的母公司FMR有限责任公司的私人股本部门，我们管理金融服务业以外的企业的投资。

公司服务

没有公司服务提供的功能专长和强大的组织支持，我们就无法做我们所做的事情。我们整个公司依靠这些协作团队和他们独特的技能来帮助我们超越客户的期望，实现我们的目标。加入我们在广泛的职业领域，在那里你的工作将影响金融未来无处不在。

关于我们

金融服务公司就是把人际关系放在第一位。致力于帮助人们过上更好的生活始于我们的员工。没有了解自己生活方式的员工，你就不可能为各行各业的客户服务。这就是为什么我们相信多样性和包容性是当今商业中最重要的两个词，不是用来检查的方式，而是有助于推动创新和成果的洞察力、经验和观点。我们致力于建立一种持久的包容和归属感文化，以吸引、发展和保留多样化的劳动力。在富达内部，你会发现许多员工管理的网络，基于共同的激情、背景和我们可以共同做出的变革的希望，将人们聚集在一起。我们的员工资源小组(ERG)和特殊利益集团(SIG)是一种强有力的参与和发展形式，为我们的员工做出了巨大贡献，帮助确保我们的产品和服务在一个欢迎和公平的环境中提供。致力于帮助人们过上更好的生活始于我们的员工

股权投资基金

股权投资基金也称为PE基金，主要分为PE以及PIPE，PE即是指未上市公司的一种股权投资方式，PIPE即是指已经上市股票的股权运作行为。

主板PE是指对于即将上市公司的股权投资方式，上市时间大致在几天到几月不等，也称为股权打新，主要投资于国内公司上市前期的一个暴涨阶段，主要板块企业上市首日即涨44%，之后涨跌幅限制比例为10%。科创板股票竞价交易设置较宽的涨跌幅限制，首次上市前5个交易日不设涨跌幅限制，科创板首批公司首日上市最低涨幅达152%，最高涨幅达到520%，其后涨跌幅限制为20%。

结构PIPE又称为融资型股权基金，针对于已经上市股票的股权投资，这类基金的特点是股权约定回报率，由机构与个人投资者共同出资，操作于上市股票后期的一种股权行为，机构向个人投资者支付股权约定回报率，至于支付收益后的总体投资盈亏都由机构承担，投资人无需担心市场出现怎样的变化，这是结构型PIPE自带的保障。</p>
			</div>
      
		</div>
	</div>
</template>

<script>
	export default {
		name: "jiangli",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			fanhui:function(){
				this.$router.push({
					path:'/'
				})
			}
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333!important;
		text-align: center;
	}
</style>
